import KanbanAutomationsAPI from 'dashboard/api/kanbanAutomations';

export default {
  async fetch({ commit }, { pipelineId, columnId } = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await KanbanAutomationsAPI.list(pipelineId, columnId);
      commit('SET_AUTOMATIONS', data.data);
      return data.data;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, payload) {
    commit('SET_UI_FLAG', { isSaving: true });
    try {
      const { data } = await KanbanAutomationsAPI.createAutomation(payload);
      commit('ADD_AUTOMATION', data.data);
      return data.data;
    } finally {
      commit('SET_UI_FLAG', { isSaving: false });
    }
  },

  async update({ commit }, { id, ...payload }) {
    commit('SET_UI_FLAG', { isSaving: true });
    try {
      const { data } = await KanbanAutomationsAPI.updateAutomation(id, payload);
      commit('UPDATE_AUTOMATION', data.data);
      return data.data;
    } finally {
      commit('SET_UI_FLAG', { isSaving: false });
    }
  },

  async delete({ commit }, id) {
    await KanbanAutomationsAPI.deleteAutomation(id);
    commit('DELETE_AUTOMATION', id);
  },
};
